import { userService } from '../../helpers/authservice/user.service'
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'))
const axios = require('axios')

export const state = {
  user: null,
  currentUser: {
    first_name: '',
    last_name: '',
    profile_picture:
      'https://www.nj.com/resizer/UF6-3JBUiF5bPmmZ0fqXCnOEzEU=/1280x0/smart/arc-anglerfish-arc2-prod-advancelocal.s3.amazonaws.com/public/ELE2VGM36FEQXEZVWW5MVKM52A.png',
  },
  easyUser: {
    email: '',
    tokens: {
      client_id: null,
      client_secret: null,
    },
  },
}

export const actions = {
  // Logs in the user.
  // eslint-disable-next-line no-unused-vars
  login({ dispatch, commit }, { email, password, client_id, client_secret, totpc }) {
    commit('loginRequest', email)
    return new Promise((resolve, reject) => {
      userService.login(email, password, client_id, client_secret, totpc).then(
        (user) => {
          user.email = email
          commit('loginSuccess', user)
          resolve(user)
        },
        (error) => {
          commit('loginFailure', error)
          dispatch('notification/error', error, { root: true })
          reject(error)
        },
      )
    })
  },

  loginSocial({ dispatch, commit }, { token, client_id, client_secret, provider }) {
    commit('loginRequest', token)

    return new Promise((resolve, reject) => {
      userService.loginSocial(token, client_id, client_secret, provider).then(
        (user) => {
          commit('loginSuccess', user)
          resolve(user)
        },
        (error) => {
          commit('loginFailure', error)
          dispatch('notification/error', error, { root: true })
          reject(error)
        },
      )
    })
  },
  async getCurrentUser({ dispatch, commit }) {
    commit('userRequest')

    userService.getCurrentUser().then(
      (user) => {
        commit('getCurrentUserSuccess', user)
      },
      (error) => {
        console.log(error)
        commit('getCurrentUserFailure', error)
        dispatch('notification/error', error, { root: true })
      },
    )
  },
  async resetPassword({ dispatch, commit }, { email }) {
    commit('resetPasswordRequest')

    userService.resetPassword({ email }).then(
      (ok) => {
        commit('resetPasswordSuccess', true)
        dispatch('notification/success', 'Check tes emails et suis les instructions!', { root: true })
      },
      (error) => {
        commit('resetPasswordFailure', error)
        dispatch('notification/error', error, { root: true })
      },
    )
  },
  async changePassword({ dispatch, commit }, { token, password }) {
    commit('changePasswordRequest')
    userService.changePassword(token, password).then(
      (ok) => {
        commit('changePasswordSuccess', true)
        router.push('/')
        dispatch('notification/success', 'Ton mot de passe à bien été changé, tu peux maintenant te connecter.', {
          root: true,
        })
      },
      (error) => {
        commit('changePasswordFailure', error)
        dispatch('notification/error', error, { root: true })
      },
    )
  },
  // Logout the user
  async logout({ commit }) {
    userService.logout()
    commit('logout')
  },
  // register the user
  async registeruser({ dispatch, commit }, user) {
    commit('registerRequest', user)
    userService.register(user).then(
      (user) => {
        commit('registerSuccess', user)
        dispatch('notification/success', 'Registration successful', { root: true })
        router.push('/companies')
      },
      (error) => {
        commit('registerFailure', error)
        dispatch('notification/error', error, { root: true })
      },
    )
  },
  // get client_id client_secret
  getApplication({ dispatch, commit }, { email }) {
    commit('getApplicationRequest')
    return new Promise((resolve, reject) => {
      userService.getApplication({ email }).then(
        (companies) => {
          commit('getApplicationSuccess', companies)
          resolve(companies)
        },
        (error) => {
          // router.push('/companies');
          console.log(error)
          commit('getApplicationFailure', error)
          dispatch('notification/error', error, { root: true })
          reject(error)
        },
      )
    })
  },
}

export const mutations = {
  loginRequest(state, email) {
    state.status = { loggingIn: true }
    state.easyUser.email = email
  },
  loginSuccess(state, user) {
    state.status = { loggeduser: true }
    state.user = user
  },
  loginFailure(state, user) {
    state.status = { loggeduser: false }
    state.user = null
  },
  userRequest(state, user_object) {
    state.currentUser = user_object
  },

  getCurrentUserSuccess(state, user) {
    state.currentUser = user
  },
  getCurrentUserFailure(state) {
    state.status = {}
    state.currentUser = null
  },
  logout(state) {
    state.status = {}
    state.user = null
  },
  registerRequest(state, email) {
    state.status = { registering: true }
    state.easyUser.email = email
  },
  registerSuccess(state) {
    state.status = {}
  },
  registerFailure(state) {
    state.status = {}
  },
  resetPasswordRequest(state) {
    state.status = { reseting: true }
  },
  resetPasswordSuccess(state) {
    state.status = { reset: true }
  },
  resetPasswordFailure(state) {
    state.status = { reset: false }
  },
  changePasswordRequest(state) {
    state.status = { changing: true }
  },
  changePasswordSuccess(state) {
    state.status = { change: true }
  },
  changePasswordFailure(state) {
    state.status = { change: false }
  },
  getApplicationRequest(state) {
    state.status = { getting: true }
  },
  getApplicationSuccess(state, companies) {
    state.status = { get: true }
    state.companies = companies
  },
  getApplicationFailure(state) {
    state.status = { get: false }
  },
}

export const getters = {
  currentUser: (state) => {
    return state.currentUser
  },
  easyUser: (state) => {
    return state.easyUser
  },
}
